(function ($) {

    const $window = $(window);
    const $body = $('body');
    const $header = $('#site-header');
    const $mainBar = $header.find('.main-bar');
    const scrollThreshold = 8;

    if (!$header.length || !$mainBar.length) {
        return;
    }

    let lastScrollTop = $window.scrollTop();
    let isHidden = false;
    let ticking = false;

    function is_desktop() {
        return !$header.hasClass('mobile');
    }

    function set_main_bar_hidden(hidden) {
        if (isHidden === hidden) {
            return;
        }

        isHidden = hidden;
        $header.toggleClass('main-bar-hidden', hidden);

        if (hidden) {
            $header.trigger('main_bar_hidden.minimizeHeader');
        }
    }

    function reset_main_bar() {
        set_main_bar_hidden(false);
        lastScrollTop = $window.scrollTop();
    }

    function update_on_scroll() {
        let scrollTop = $window.scrollTop();
        let delta = scrollTop - lastScrollTop;

        if (!is_desktop() || $body.hasClass('menu-open')) {
            reset_main_bar();
            return;
        }

        if (Math.abs(delta) < scrollThreshold) {
            return;
        }

        set_main_bar_hidden(delta > 0 && scrollTop > $mainBar.outerHeight());
        lastScrollTop = scrollTop;
    }

    function request_scroll_update() {
        if (ticking) {
            return;
        }

        ticking = true;
        window.requestAnimationFrame(function () {
            update_on_scroll();
            ticking = false;
        });
    }

    window.addEventListener('scroll', request_scroll_update, { passive: true });
    $window.on('resize.minimizeHeader breakpoint_changed.minimizeHeader', reset_main_bar);

})(jQuery);
